import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newProduct({ commit }) {
    let productDetails = {
      product_name: $(".product_name").val(),
      product_description: $(".product_description").val(),
      product_measurement: $(".product_measurement").val(),
      buying_price: $(".buying_price").val(),
      selling_price: $(".selling_price").val(),
      minimum_stock_level: $(".minimum_stock_level").val()
    };
    $(".creatingProduct").hide();
    $(".creatingProductLoader").show();
    baseurl.post(rt.newProduct, productDetails).then(res => {
      $(".creatingProduct").show();
      $(".creatingProductLoader").hide();
      $(".form-control").val("");

      //checking for response codes from backend api

      if (res.data.code === 200) {
        window.$("#new-product").modal("hide");
        //success code
        setTimeout(() => {
          commit("STORE_PRODUCTS", res.data.products);
        }, 2000);

        suc.productCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //product exits
        ers.productExists();
      } else if (res.data.code === 404) {
        //error on creating product
        ers.errorCreatingProduct();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //sessions expired
        ses.sessionComplete();
      }
    });
  },

  loadProduct({ commit }) {
    baseurl.get(rt.loadProducts).then(res => {
      $(".productsLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code and committing mutations
        commit("STORE_PRODUCTS", res.data.products);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingProducts();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        commit("STORE_PRODUCTS", []);
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  loadProductstat({ commit }) {
    baseurl.get(rt.loadProductstat).then(res => {
      $(".productsLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code and committing mutations
        commit("STORE_PRODUCT_STAT", res.data.statproductsales);
        commit("STORE_PRODUCT_TOTAL_SALES", res.data.total);
        commit("STORE_PRODUCT_TOTAL_PURCHASE", res.data.topPurchasedProducts);
        commit("STORE_PRODUCT_TOTAL_SALE", res.data.topSoldProducts);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingProducts();
      } else if (res.data.code === 405) {
        //no permission to read
        // ers.noPermissionToRead();
        commit("STORE_PRODUCT_STAT", res.data.statproductsales);
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  getProduct({ commit },product_id) {
    let productDetail = {
      product_id: product_id
    }
    baseurl.post(rt.getProducts, productDetail).then(res => {
      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code and committing mutations
        commit("STORE_PRODUCT", res.data.singleproducts);
        commit("STORE_SELLING_PRICE", res.data.sellprice);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingProducts();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  getDeadProduct({ commit },product_id) {
    let productDetail = {
      product_id: product_id
    }
    baseurl.post(rt.getDeadProducts, productDetail).then(res => {
      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code and committing mutations
        commit("STORE_DEFECTIVE_PRODUCT", res.data.deadproducts);
        commit("STORE_SELLING_PRICE", res.data.sellprice);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingProducts();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewProduct({ commit }, productId) {
    commit("STORE_PRODUCT_UPDATE", productId);
    router.push("/updateproduct");
  },
  viewProducts({ commit }, productId) {
    commit("STORE_PRODUCT_UPDATE", productId);
  },
  stockProduct({ commit }, productId) {
    commit("STORE_PRODUCT_UPDATE", productId);
    router.push("/addstock");
  },
  deadstockProduct({ commit }, productId) {
    commit("STORE_PRODUCT_UPDATE", productId);
    router.push("/adddeadstock");
  },

  updateProduct({ commit }) {
    let productDetails = {
      id: $(".id").val(),
      product_name: $(".product_name").val(),
      product_description: $(".product_description").val(),
      product_measurement: $(".product_measurement").val(),
      minimum_stock_level: $(".minimum_stock_level").val()
    };
    $(".updatingProduct").hide();
    $(".updatingProductLoader").show();
    baseurl.post(rt.updateProduct, productDetails).then(res => {
      $(".updatingProduct").show();
      $(".updatingProductLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.productUpdateSuccess();
        setTimeout(() => {
          router.push("/manageproducts");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //errror on updating data
        ers.errorUpdatingProduct();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadProductnumber({ commit }) {
    baseurl.get(rt.loadNumber).then(res => {
      commit("STORE_PROD_NO", res.data.prod_no);
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/products/actions.js